module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-Medium.2a5205b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/AvenirNextLTPro-Medium.svg
// module id = 234
// module chunks = 0